import { useTeam } from 'app/frontend/base/config/context/team'
import { useAuth } from 'app/frontend/base/config/context/auth'
import RaidPlansOverviewContent from './RaidPlansOverviewContent'
import TeamPlansIntro from './TeamPlansIntro'
import DefaultSetupCard from './default_setup/DefaultSetupCard'

const TeamPlansOverview = () => {
  const { team } = useTeam()
  const { accessLevel } = useAuth()
  const canEdit = accessLevel === 'admin'

  return (
    <RaidPlansOverviewContent
      owner={{ ownerType: 'team', ownerId: team.id }}
      basePath={`${team.path}/events/plans`}
      canEdit={canEdit}
      intro={<TeamPlansIntro eventsPath={`${team.path}/events`} />}
      encounterOrders={team.encounterOrders}
      afterPlans={({ encounter, instance, difficulty, season }) => (
        <DefaultSetupCard
          encounter={encounter}
          instance={instance}
          difficulty={difficulty}
          season={season}
          canEdit={canEdit}
        />
      )}
    />
  )
}

export default TeamPlansOverview
